import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles<
  Theme,
  {
    maxHeight?: number | string;
  }
>(theme => ({
  paper: {
    boxShadow: "none",
    margin: 0
  },

  popperDisablePortal: {
    position: "relative"
  },

  option: {
    height: 25,
    padding: 0,
    display: "flex",
    alignItems: "center",
    margin: "0 5px 3px",
    opacity: "1 !important"
  },

  listbox: {
    maxHeight: ({ maxHeight }) => maxHeight,

    "&::-webkit-scrollbar": {
      width: "5px",
      backgroundColor: "transparent"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#fafafa"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ccc",
      borderRadius: "5px"
    },
    "& > li:first-child": {
      position: "relative",
      marginBottom: 16,
      "&::after": {
        content: "''",
        height: "1px",
        backgroundColor: theme.palette.divider,
        position: "absolute",
        bottom: -8,
        left: -5,
        right: -5
      }
    }
  }
}));
